export const noop = () => {};
export const nextTick = (cb) => setTimeout(cb);
export const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
